import type { TRuleWithTheme } from 'styles';

export const container: TRuleWithTheme = ({ theme }) => ({
    width: theme.form.formWrapperWidth,
});

export const lastFormItem: TRuleWithTheme = () => ({
    marginBottom: 0,
});
